import { useCallback, useEffect, useState } from 'react';

import { useGenerateProductReporting } from ':cloud/queries/Projects/useGenerateProductReporting';
import { useGetProductReportingStatus } from ':cloud/queries/Projects/useGetProductReportingStatus';
import { ProductTypeCOMS, Project } from ':cloud/types/ts_types';
import { handleDownload } from ':cloud/utils/files';

type TransactionsReportingProps = {
  project: Project;
  productType: ProductTypeCOMS;
  startDate: string;
  endDate: string;
};

export function useGenerateTransactionsReporting({
  project,
  productType,
  startDate,
  endDate,
}: TransactionsReportingProps) {
  const [runId, setRunId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const { mutateAsync: generateReport } = useGenerateProductReporting(project, productType);
  const { data: statusData } = useGetProductReportingStatus(project, productType, runId || '');

  const startReportGeneration = useCallback(async () => {
    setIsLoading(true);
    try {
      const newRunId = await generateReport({ startDate, endDate });
      setRunId(newRunId);
    } catch (e) {
      setRunId(null);
      setIsLoading(false);
    }
  }, [generateReport, startDate, endDate]);

  useEffect(() => {
    if (statusData?.s3DownloadUrl) {
      handleDownload(statusData.s3DownloadUrl);
      setIsLoading(false);
    }
  }, [statusData?.s3DownloadUrl]);

  return { isLoading, startReportGeneration };
}
